import BaseModel from "./BaseModel";

export default class SocialProfiles extends BaseModel {
	constructor(restApi) {
		super(restApi, "SocialProfiles", null);
		
		this.restApi = restApi;
	}
  
	static moduleSingular() {
		return "SocialProfile";
	}
	
	static modulePlural() {
		return "SocialProfiles";
	}
  
  static nameMapping() {
    return [
      { "modelName": "id", "apiName": "id" },
      { "modelName": "site", "apiName": "site", "defaultValue": "" },
      { "modelName": "email", "apiName": "email", "defaultValue": "" },
      { "modelName": "username", "apiName": "username", "defaultValue": "" },
      { "modelName": "keyword", "apiName": "keyword", "defaultValue": "" },
      { "modelName": "password", "apiName": "password", "defaultValue": "" },
      { "modelName": "url", "apiName": "url", "defaultValue": "" },
      { "modelName": "content", "apiName": "content", "defaultValue": "" },
      { "modelName": "error", "apiName": "error", "defaultValue": false },
      { "modelName": "onlyCreateAfter", "apiName": "onlyCreateAfter", "defaultValue": "" },
      { "modelName": "created", "apiName": "created", "defaultValue": false },
      { "modelName": "createdAt", "apiName": "createdAt", "defaultValue": "" },
      { "modelName": "clientId", "apiName": "clientId", "defaultValue": "" }
    ];
  }
	
	static createModel(restApi, jsonObject) {
		return BaseModel.createModel(SocialProfiles, restApi, jsonObject, SocialProfiles.nameMapping());
	}
}



// WEBPACK FOOTER //
// ./src/modules/SocialProfiles.js